import { z } from 'zod';
import {
  INSTITUTE_TYPE_CODE_MAX_LENGTH,
  INSTITUTE_TYPE_NAME_MAX_LENGTH,
} from '../constants/instituteType.constants';

export const instituteTypeSchema = z.object({
  id: z.coerce.number(),
  name: z.string(),
  code: z.string().nullable(),
  isActive: z.boolean(),
  requiresEiin: z.boolean(),
  createdAt: z.coerce.date(),
  updatedAt: z.coerce.date(),
});

export const instituteTypeListSchema = z.array(instituteTypeSchema);

export type InstituteType = z.infer<typeof instituteTypeSchema>;

export const instituteTypeFormSchema = z.object({
  name: z
    .string()
    .trim()
    .min(1, 'Name is required')
    .max(
      INSTITUTE_TYPE_NAME_MAX_LENGTH,
      `Name must be ${INSTITUTE_TYPE_NAME_MAX_LENGTH} characters or fewer`,
    ),
  code: z
    .string()
    .trim()
    .max(
      INSTITUTE_TYPE_CODE_MAX_LENGTH,
      `Code must be ${INSTITUTE_TYPE_CODE_MAX_LENGTH} characters or fewer`,
    ),
  isActive: z.boolean(),
  requiresEiin: z.boolean(),
});

export type InstituteTypeFormValues = z.infer<typeof instituteTypeFormSchema>;

export interface CreateInstituteTypePayload {
  name: string;
  code?: string;
  isActive?: boolean;
  requiresEiin?: boolean;
}

export type UpdateInstituteTypePayload = Partial<CreateInstituteTypePayload>;
